import React from 'react';
import { Checkbox } from '@material-ui/core';
import clsx from 'clsx';
import { Info } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import { CustomerDto } from '../../../api/orders';
import { useStyles } from './styles';
import { Props } from './props';
import { format, parse } from 'date-fns';
import { isDeliveryType } from 'pages/Orders/types';

const formatDateRange = (start: Date, end: Date) => {
    const parseDate = (date: Date) => {
        if (typeof date === 'string') {
            return parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
        }
        return date;
    };

    const startDate = parseDate(start);
    const endDate = parseDate(end);

    if (!startDate && !endDate) {
        return '-';
    }

    const datePart = startDate ? format(startDate, 'dd.MM.yyyy') : format(endDate, 'dd.MM.yyyy');
    const startTime = startDate ? format(startDate, 'HH:mm') : '-';
    const endTime = endDate ? format(endDate, 'HH:mm') : '-';
    return `${datePart} (${startTime} - ${endTime})`;
};

const OrderTableItem = ({
    handleOpenDetails,
    handleClick,
    isItemSelected,
    item,
    singleSelect,
    labelId,
    isGeozoning,
}: Props) => {
    const classes = useStyles();

    return (
        <table
            onClick={() => handleClick(item)}
            role="checkbox"
            aria-checked={isItemSelected}
            key={item.id}
            className={classes.table}
        >
            <colgroup>
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
            </colgroup>
            <thead>
                <tr>
                    <td
                        colSpan={4}
                        className={clsx(classes.tableTitle, isItemSelected && classes.selected)}
                    >
                        <div className={classes.tableHeader}>
                            <div>
                                {!singleSelect && (
                                    <Checkbox
                                        color="primary"
                                        className={classes.checkbox}
                                        checked={isItemSelected}
                                        inputProps={{
                                            'aria-labelledby': labelId,
                                        }}
                                    />
                                )}
                                <IconButton
                                    className={classes.openIcon}
                                    onClick={(e: any) => {
                                        handleOpenDetails(item.id);
                                        e.stopPropagation();
                                    }}
                                >
                                    <Info />
                                </IconButton>
                                <span className={classes.captionText}>Номер заявки: </span>
                                <span>{item.order_number}</span>
                            </div>
                            <div>
                                <span className={classes.captionText}>Владелец: </span>
                                <span>{`${item?.tenant?.last_name || ''} ${
                                    item?.tenant?.first_name || ''
                                }`}</span>
                            </div>
                            <div>
                                <span className={classes.captionText}>Статус: </span>
                                <span>{item.order_status?.description}</span>
                            </div>
                            <div>
                                <span className={classes.captionText}>Регион: </span>
                                <span>{item.region?.description}</span>
                            </div>
                            <div>
                                <div>
                                    <span className={classes.captionText}>Дата создания: </span>
                                    <span>{item.date_created}</span>
                                </div>
                                {item?.order_detail?.collection_date ? 
                                    <div>
                                        <span className={classes.captionText}>Дата забора: </span>
                                        <span>{item?.order_detail?.collection_date}</span>
                                    </div>
                                    : null
                                }
                                {item?.order_detail?.collection_time ? 
                                    <div>
                                        <span className={classes.captionText}>Время забора: </span>
                                        <span>{item?.order_detail?.collection_time}</span>
                                    </div>
                                    : null
                                }
                            </div>
                            {
                                (
                                    item?.order_detail?.delivery_type === "INTAKE_INDIVIDUAL" ||
                                    item?.order_detail?.delivery_type === "INTAKE"
                                ) &&
                                (
                                    item?.order_status?.code === "PLANNED" ||
                                    item?.order_status?.code === "RECEIVED"
                                ) ? (
                                    <div>
                                        <span className={classes.captionText}>Дата забора: </span>
                                        <span>{item?.order_detail?.courier_arrived_date || '-'}</span>
                                    </div>
                                ) : (
                                    <div>
                                        <span className={classes.captionText}>Возвратное: </span>
                                        <span>{item?.is_return ? 'Да' : 'Нет'}</span>
                                    </div>
                                )
                            }
                            <div>
                                <span className={classes.captionText}>Вес: </span>
                                <span>{item.order_detail.weight}</span>
                            </div>
                            {item?.order_detail?.delivery_type === 'PENSION' && (
                                <div>
                                    <span className={classes.captionText}>Сумма: </span>
                                    <span>{`${item?.order_detail?.issue_sum} тг.`}</span>
                                </div>
                            )}

                            {
                                item?.product?.code !== "PPI" ?
                                (<div>
                                    <span className={classes.captionText}>Комментарий: </span>
                                    <span>
                                        {item?.order_address?.source?.order_comment ? ((item?.product?.code === 'PLS' || 
                                                                                       item?.product?.code === 'PLS_NO_IIN' || 
                                                                                       item?.product?.code === 'PUS_ARCHIVED') ? 'Доставка на дом' : 'Да') : 'Нет'}
                                    </span>
                                </div>) :
                                
                                 (<div>
                                    <span className={classes.captionText}>Наименование издания:</span>
                                    <span>{item?.newspapers[0]?.name}</span>
                                </div>)
                            }
                            
                            <div>
                                <span className={classes.captionText}>Количество отправлений:</span>
                                <span>{item?.product?.code !== "PPI" ? item?.order_detail?.item_count : item?.newspapers[0]?.amount}</span>
                            </div>
                            <div>
                                <span className={classes.captionText}>Наложенный платеж: </span>
                                <span>{item?.order_detail?.with_payment ? 'Да' : 'Нет'}</span>
                            </div>
                            <div className={classes.rightText}>
                                <span className={classes.captionText}>
                                    C денежной наличностью:{' '}
                                </span>
                                <span>{item?.order_detail?.with_money ? 'Да' : 'Нет'}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <span className={classes.captionText}>Продукт:</span>
                        <span>{item.product?.description}</span>
                    </td>
                    <td
                        style={{background: item.order_address?.source?.latitude || isDeliveryType(item.order_detail.delivery_type) || !isGeozoning ? 'white': 'red'}}
                    >
                        <span className={classes.captionText}>Адрес отправки: </span>
                        <span>
                            {item.order_address?.source?.region?.description},
                            {item.order_address?.source?.address}  ({item.order_address?.source?.latitude ? item.order_address?.source?.latitude + ', ' + item.order_address?.source?.longitude : '-'})
                        </span>
                    </td>
                    <td style={{background: item.order_address?.target?.latitude || !isDeliveryType(item.order_detail.delivery_type) || !isGeozoning ? 'white': 'red'}}>
                        <span className={classes.captionText}>Адрес доставки: </span>
                        <span>{item.order_address?.target?.address} ({item.order_address?.target?.latitude ? item.order_address?.target?.latitude + ', ' + item.order_address?.target?.longitude : '-'})</span>
                    </td>
                    <td style={{background: item.isGeozoneFined || !isGeozoning ? 'white' : 'red'}}>
                        <span className={classes.captionText}>Зона: </span>
                        <span>{item.geozone_name ? item.geozone_name : '-'}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span className={classes.captionText}>Курьер: </span>
                        <span>
                            {item.courier
                                ? [
                                      `${item.courier?.last_name} ${item.courier?.first_name}`,
                                      item.courier?.phone_number,
                                  ].join(', ')
                                : ''}
                        </span>
                    </td>
                    <td>
                        <span className={classes.captionText}>Отправитель: </span>
                        <span>
                            {item.customers
                                .filter((c: CustomerDto) => c.relation_type !== 'RECEIVER')
                                .map((client: CustomerDto, clientIdx: number) => (
                                    <span key={clientIdx}>
                                        {`${client.customer?.name} ${
                                            client.customer?.surname || ''
                                        }`}
                                        {client.customer?.phone_number &&
                                            `, ${client.customer?.phone_number}`}
                                    </span>
                                ))}
                        </span>
                    </td>
                    <td>
                        <span className={classes.captionText}>Получатель: </span>
                        <span>
                            {item.customers
                                .filter((c: CustomerDto) => c.relation_type === 'RECEIVER')
                                .map((client: CustomerDto, clientIdx: number) => (
                                    <span key={clientIdx}>
                                        {client.customer.full_name}
                                        {client.customer?.phone_number &&
                                            `, ${client.customer?.phone_number}`}
                                    </span>
                                ))}
                        </span>
                    </td>
                    <td>
                        <span className={classes.captionText}>Дата плановой доставки: </span>
                        <span>{formatDateRange(item.date_plan_delivery_period_start,item.date_plan_delivery_period_end)}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default OrderTableItem;
